'use client'
import {
  addOrRemoveCompanyLocation,
  addOrRemoveCompanyLocationContinents,
  addOrRemoveProductLocation,
  addOrRemoveProductLocationContinents,
} from '@/app/globalRedux/filter/commonFilter'
import {
  addOrRemoveFruitVegetableActivity,
  addOrRemoveFvProductFilterSelectedProduct,
  Product,
  setAddOrRemoveAvailability,
  setCultivationType,
} from '@/app/globalRedux/filter/productFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import Tag from '@/components/ui/Tag'
import { useDispatch, useSelector } from 'react-redux'

const FruitVegetableFilter = () => {
  const { t } = useTranslation()
  const productsFilter = useSelector((state: RootState) => state.productFilter)
  const commonFilter = useSelector((state: RootState) => state.commonFilter)

  const dispatch = useDispatch()

  const handleCultivationChange = (cultivationType: string) => {
    dispatch(setCultivationType(cultivationType))
  }

  const handleActivityChange = (activity: string) => {
    dispatch(addOrRemoveFruitVegetableActivity(activity))
  }

  const handleAvailabilityChange = (availability: string) => {
    dispatch(setAddOrRemoveAvailability(availability))
  }

  const handleCompanyLocationChange = (location: any) => {
    dispatch(addOrRemoveCompanyLocation(location))
  }

  const handleCompanyLocationContinentsChange = (continent: any) => {
    dispatch(addOrRemoveCompanyLocationContinents(continent))
  }

  const handleProductLocationChange = (location: any) => {
    dispatch(addOrRemoveProductLocation(location))
  }

  const handleProductLocationContinentsChange = (continent: any) => {
    dispatch(addOrRemoveProductLocationContinents(continent))
  }
  const handleProductChange = (product: Product) => {
    dispatch(addOrRemoveFvProductFilterSelectedProduct(product))
  }

  const filterItems = [
    ...productsFilter.cultivationType?.map((item) => ({
      value: item,
      label: 'cultivation',
      callback: handleCultivationChange,
    })),

    ...productsFilter.productFruitVegetableActivity?.map((item) => ({
      value: item,
      label: 'activity',
      callback: handleActivityChange,
    })),
    ...(productsFilter.productFVAvailability
      ? [
          {
            value: productsFilter.productFVAvailability,
            label: 'availability',
            callback: handleAvailabilityChange,
          },
        ]
      : []),
    ...productsFilter.productFilterFvSelectedProducts?.map((item: Product) => ({
      value: item.name,
      label: 'product',
      callback: () => handleProductChange(item),
    })),
    ...commonFilter.companyLocation?.map((item) => ({
      value: item,
      label: 'companyLocation',
      callback: handleCompanyLocationChange,
    })),
    ...commonFilter.companyLocationContinents?.map((item) => ({
      value: item,
      label: 'companyLocationContinent',
      callback: handleCompanyLocationContinentsChange,
    })),
    ...commonFilter.productLocation?.map((item) => ({
      value: item,
      label: 'productLocation',
      callback: handleProductLocationChange,
    })),
    ...commonFilter.productLocationContients?.map((item) => ({
      value: item,
      label: 'productLocationContinent',
      callback: handleProductLocationContinentsChange,
    })),
  ]

  return (
    <div className="flex-wrap gap-2 flex flex-row">
      {filterItems
        .slice(0, 2)
        ?.map((filter: any, index) => (
          <Tag
            key={index}
            label={t(filter.value?.name ? filter.value?.name : filter.value)}
            callBackFunction={() => filter.callback(filter.value)}
          />
        ))}
    </div>
  )
}

export default FruitVegetableFilter
